import axios from "axios"
export function sendApplicationComment(email, fname, body, token) {
    return axios.post(process.env.REACT_APP_API_URL + '/sendApplicationComment', { email: email, fname: fname, body: body },
      {  headers: {
        'Authorization': `${token}`
    }});
}